import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App, { SiteNav } from './App';
import Furdle from './Furdle';
import MBI from './MBI';
import reportWebVitals from './reportWebVitals';

function UtilityPage({ title, description, children }) {
  return (
    <div className="utility-page">
      <SiteNav />
      <main>
        <div className="utility-page-heading">
          <p className="eyebrow">Utilities</p>
          <h1>{title}</h1>
          <p>{description}</p>
        </div>
        <div className="utility-panel">{children}</div>
      </main>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route
          path="/mbi"
          element={
            <UtilityPage
              title="MBI Generator"
              description="A small helper for generating sample Medicare Beneficiary Identifier-style values."
            >
              <MBI />
            </UtilityPage>
          }
        />
        <Route path="/furdle" element={<Furdle />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
